import ShippingPage from '../../components/ShippingPage';
import ShippingRestrictionForm from '../components/ShippingRestrictionForm';
import { useShippingRestrictionPage } from '../hooks';

function NewShippingRestrictionPage(): JSX.Element {
  const {
    values,
    handleOnSubmit,
    handleChange,
    setFieldValue,
    errors,
    isUpdating,
    isError,
    title,
    isConfirmDisabled,
  } = useShippingRestrictionPage({ mode: 'create' });

  return (
    <ShippingPage
      title={title}
      handleSave={handleOnSubmit}
      isUpdating={isUpdating}
      isError={isError}
      isConfirmDisabled={isConfirmDisabled}
    >
      {!isError && (
        <ShippingRestrictionForm
          values={values}
          onChange={handleChange}
          onArrayChange={setFieldValue}
          errors={errors}
        />
      )}
    </ShippingPage>
  );
}

export default NewShippingRestrictionPage;
